import {
  parseISO,
  format,
  subMinutes,
  addMinutes,
  isDate,
  isWithinInterval,
} from "date-fns";

var DateHelper = {
  /**
   * Parse Backend iso string to JS date Obj
   */
  parseDateFromBackend: (date) => {
    if (date && typeof date.getMonth === "function") {
      return date;
    } else {
      return parseISO(date);
    }
  },

  parseRawDate: (date) => {
    const datePieces = date.split("-");
    return new Date(
      parseInt(datePieces[0]),
      parseInt(datePieces[1]) - 1,
      parseInt(datePieces[2])
    );
  },

  /**
   * print date or time to screen for view
   */

  printDateToScreen: function (date, dateFormat, offsetTime = false) {
    var d = typeof date === "string" ? parseISO(date) : new Date(date);
    if (offsetTime) {
      d = this.hotelAdjustDate(d);
    }

    var df = this.rubyToDateFNS(dateFormat);

    return format(d, df);
  },

  rubyToDateFNS: function (format) {
    var format = format || "";

    // make sure format exists and requires transformation
    if (!format || format == "" || format.indexOf("%") == -1) {
      format = format.replace(/D/g, "d");
      format = format.replace(/Y/g, "y");
      return format;
    }

    // date formats
    format = format.replace(/%B/g, "MMMM");
    format = format.replace(/%b/g, "MMM");
    format = format.replace(/%-m/g, "M");
    format = format.replace(/%m/g, "MM");
    format = format.replace(/%-d/g, "d");
    format = format.replace(/%d/g, "dd");
    format = format.replace(/%D/g, "d");
    format = format.replace(/%Y/gi, "yyyy");

    // time formats
    format = format.replace(/%l/g, "h");
    format = format.replace(/%I/g, "hh");
    format = format.replace(/%M/g, "mm");
    format = format.replace(/%P/g, "aaa");
    format = format.replace(/%p/g, "a");

    // cleanup
    format = format.replace(/%/g, "");

    return format;
  },

  /**
   * Returns the current date/time adjusted to be the time of the hotel property
   *
   * @param {integer} time_zone_offset The time zone offset of the hotel property
   */
  current: function (time_zone_offset, display_format) {
    var time_zone_offset = time_zone_offset
      ? time_zone_offset
      : $("#time_zone_offset").length
      ? $("#time_zone_offset").val()
      : 0;
    var current = new Date();
    var adjusted_time = new Date(current.getTime());

    adjusted_time.setTime(
      current.getTime() +
        (time_zone_offset - DateHelper.getBrowserTimeZoneOffset()) * 1000
    );
    return adjusted_time;
  },

  /**
   * Returns the date/time adjusted to be the time of the hotel property
   *
   * @param {date} date
   * @param {integer} time_zone_offset The time zone offset of the hotel property
   */
  hotelAdjustDate: function (date, time_zone_offset) {
    var time_zone_offset = time_zone_offset
      ? time_zone_offset
      : window.top.document.querySelector("#time_zone_offset")
      ? window.top.document.querySelector("#time_zone_offset").value
      : 0;
    var browser_time_zone_offset = DateHelper.getBrowserTimeZoneOffset();
    var adjusted_time = new Date(date.getTime());

    adjusted_time.setTime(
      date.getTime() + (time_zone_offset - browser_time_zone_offset) * 1000
    );
    return adjusted_time;
  },

  reverseOffset: function (date, time_zone_offset) {
    var time_zone_offset = time_zone_offset
      ? time_zone_offset
      : window.top.document.querySelector("#time_zone_offset")
      ? window.top.document.querySelector("#time_zone_offset").value
      : 0;
    var browser_time_zone_offset = DateHelper.getBrowserTimeZoneOffset();
    var adjusted_time = new Date(date.getTime());

    adjusted_time.setTime(
      date.getTime() - (time_zone_offset - browser_time_zone_offset) * 1000
    );

    return adjusted_time;
  },


  /**
   * Determines if any date in a range is between another date range
   *
   * @param {date} startDate1
   * @param {date} endDate1
   * @param {date} startDate2
   * @param {date} endDate2
   */
  between: function (startDate1, endDate1, startDate2, endDate2) {
    var isBetween = false;

    for (
      var d1 = new Date(startDate1);
      d1 < new Date(endDate1);
      d1.setDate(d1.getDate() + 1)
    ) {
      if (isWithinInterval(d1, { start: startDate2, end: endDate2 })) {
        isBetween = true;
        break;
      }
    }

    return isBetween;
  },

  /**
   * Calculates the difference in days between two dates
   *
   * @param {date} startDate
   * @param {date} endDate
   *
   * @returns {integer}
   */
  diffInDays: function (startDate, endDate) {
    var MS_PER_DAY = 1000 * 60 * 60 * 24;
    var utc1 = Date.UTC(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );
    var utc2 = Date.UTC(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );
    return Math.round((utc2 - utc1) / MS_PER_DAY);
  },

  /**
   * Calculates the duration in minutes between a start and end date
   *
   * @param {date} start
   * @param {date} end
   *
   * @return {integer} minutes
   */
  durationInMinutes: function (start, end) {
    var diff = Math.abs(end.getTime() - start.getTime());

    return diff / (60 * 1000);
  },

  getBrowserTimeZoneOffset: function () {
    var current_date = new Date();
    return current_date.getTimezoneOffset() * -60;
  },

  /**
   * Retrieves the 'hours' portion of a date string
   *
   * @param {string} date
   *
   * @returns {integer} hours
   */
  getHours: function (date) {
    var timePieces = this.getTimePieces(date);
    return timePieces[0];
  },

  /**
   * Parses and splits a date string into "time pieces" array (hours = 0, minutes = 1, seconds = 2)
   */
  getTimePieces: function (date) {
    if (date && date.indexOf("T") != -1) {
      return date.split("T")[1].slice(0, -1).split(":");
    }
  },

  /**
   * Gets the week number index of when the date appears in the month
   *
   * @param {date} date
   *
   * @returns {integer) index
   */
  getWeek: function (date) {
    var startDay = DateHelper.startOfMonth(date).getDay();

    return parseInt((date.getDate() + startDay) / 7, 10);
  },

  /**
   * Gets the number of weeks in the given month
   *
   * @param {date}
   *
   * @returns {integer}
   */
  getWeeksInMonth: function (date) {
    var firstOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastOfMonth = new Date(date.getFullYear(), date.getMonth() - 1, 0);

    var used = firstOfMonth.getDay() + lastOfMonth.getDate();

    return Math.ceil(used / 7);
  },

  /**
   * Determines whether the object passed in is a Date object
   */
  isDate: function (d) {
    return d instanceof Date;
  },

  /**
   * Convert a UTC date into a local time
   */
  local: function (date) {
    var d = new Date();
    var offset = d.getTimezoneOffset();
    var localDate = new Date(date);

    if (offset > 0) {
      subMinutes(localDate, offset);
    } else if (offset < 0) {
      addMinutes(localDate, offset);
    }

    return localDate;
  },

  /**
   * Convert a local date into server (UTC) time
   */
  server: function (date) {
    var d = new Date();
    var offset = d.getTimezoneOffset();
    var localDate = date ? new Date(date) : new Date();

    if (offset > 0) {
      addMinutes(localDate, offset);
    } else if (offset < 0) {
      subMinutes(localDate, offset);
    }

    return localDate;
  },

  /**
   * Convenience function to call parseDate
   */
  parse: function (d) {
    return this.parseDate(d);
  },

  /**
   * Returns a date object for the passed in date string
   *
   * @param {date} String
   *
   * @returns {date} date
   */
  parseDate: function (d, offsetTime = false) {
    if (d && !this.isDate(d)) {
      var timePieces = this.getTimePieces(d);
      var datePieces = d.split("T")[0].split("-");
      var d = new Date(
        parseInt(datePieces[0], 10),
        parseInt(datePieces[1], 10) - 1,
        parseInt(datePieces[2], 10)
      );

      if (timePieces && timePieces.length >= 3) {
        d.setHours(timePieces[0], 10);
        d.setMinutes(timePieces[1], 10);
        d.setSeconds(
          this.sanitizeSecondsString(timePieces[2].split(".")[0]),
          10
        );
      }

      return d;
    } else {
      if (offsetTime) {
        d = this.hotelAdjustDate(d);
      }

      return d;
    }
  },

  /**
   * Sanitizes the seconds portion of a date string
   */
  sanitizeSecondsString(seconds) {
    return parseInt(seconds, 10);
  },

  /**
   * Returns a date object for today with the time of the passed in date
   *
   * @param {date} date
   *
   * @returns {date} date
   */
  parseTime: function (date) {
    if (isDate(date)) {
      return date;
    } else if (typeof date.indexOf === "function" && date.indexOf("-") !== -1) {
      return new Date(date);
    } else if (typeof date.indexOf === "function" && date.indexOf("T") === -1) {
      var timePieces = date.split(":");
      var timeDate = new Date();
      timeDate.setHours(parseInt(timePieces[0]));
      timeDate.setMinutes(parseInt(timePieces[1]));
      return timeDate;
    } else if (typeof date.indexOf === "function" && date.indexOf("T") !== -1) {
      var timePieces = this.getTimePieces(date);
      var today = this.current();

      if (Array.isArray(timePieces)) {
        today.setHours(timePieces[0]);
        today.setMinutes(timePieces[1]);
        today.setSeconds(timePieces[2]);
        return today;
      } else {
        return date;
      }
    } else {
      return new Date(date);
    }
  },

  formatTime: function (date, timeFormat) {
    try {
      return format(date, timeFormat || "p");
    } catch (e) {
      return date;
    }
  },

  /**
   * Transforms a Ruby date format into a datepicker date format
   */
  rubyToDatepicker: function (format) {
    var format = format || "";

    // fix dateJS formatted dates
    format = format.replace(/MM/g, "M");

    // make sure format exists and requires transformation
    if (!format || format == "" || format.indexOf("%") == -1) {
      return format;
    }

    // date formats
    format = format.replace(/%B/g, "MM");
    format = format.replace(/%b/g, "M");
    format = format.replace(/%-m/gi, "m");
    format = format.replace(/%m/gi, "mm");
    format = format.replace(/%-d/gi, "d");
    format = format.replace(/%d/gi, "dd");
    format = format.replace(/%Y/g, "yyyy");
    format = format.replace(/%/g, "");

    // cleanup
    format = format.replace(/%/g, "");

    return format;
  },

  rubyToDateJS: function (format) {
    var format = format || "";

    // make sure format exists and requires transformation
    if (!format || format == "" || format.indexOf("%") == -1) {
      return format;
    }

    // date formats
    format = format.replace(/%B/g, "MMMM");
    format = format.replace(/%b/g, "MMM");
    format = format.replace(/%-m/g, "M");
    format = format.replace(/%m/g, "MM");
    format = format.replace(/%-d/g, "d");
    format = format.replace(/%d/g, "dd");
    format = format.replace(/%Y/g, "yyyy");

    // time formats
    format = format.replace(/%l/g, "h");
    format = format.replace(/%I/g, "hh");
    format = format.replace(/%M/g, "mm");
    format = format.replace(/%P/g, "tt");
    format = format.replace(/%p/g, "tt");

    // cleanup
    format = format.replace(/%/g, "");

    return format;
  },

  rubyToDateRange: function (format) {
    var format = format || "";

    // make sure format exists and requires transformation
    if (!format || format == "" || format.indexOf("%") == -1) {
      return format;
    }

    // date formats
    format = format.replace(/%B/g, "MMMM");
    format = format.replace(/%b/g, "MMM");
    format = format.replace(/%-m/g, "M");
    format = format.replace(/%m/g, "MM");
    format = format.replace(/%-d/g, "d");
    format = format.replace(/%d/g, "DD");
    format = format.replace(/%Y/gi, "YYYY");

    // time formats
    format = format.replace(/%l/g, "h");
    format = format.replace(/%I/g, "hh");
    format = format.replace(/%M/g, "mm");
    format = format.replace(/%P/g, "a");
    format = format.replace(/%p/g, "a");

    // cleanup
    format = format.replace(/%/g, "");

    return format;
  },

  /**
   * Seconds between dates
   */
  secondsBetweenDates: function (d1, d2) {
    var diff = d1.getTime() - d2.getTime();

    return Math.floor(Math.abs(diff / 1000));
  },

  /**
   * Returns a date object for the start of the month (i.e the 1st) for the given date
   *
   * @param {date} date
   *
   * @returns {date} date
   */
  startOfMonth: function (date) {
    return date.clone().moveToFirstDayOfMonth();
  },

  /**
   * Returns a date object for the end of the month (i.e the last calendar day) for the given date
   *
   * @param {date} date
   *
   * @returns {date} date
   */
  endOfMonth: function (date) {
    return date.clone().moveToLastDayOfMonth();
  },

  /**
   * Returns a date object for the start of the week (i.e Sunday) for the given date
   *
   * @param {date} date
   *
   * @returns {date} date
   */
  startOfWeek: function (date) {
    return date.clone().moveToDayOfWeek(0, -1);
  },

  /**
   * Returns a date object for the end of the week (i.e Saturday) for the given date
   *
   * @param {date} date
   *
   * @returns {date} date
   */
  endOfWeek: function (date) {
    if (date.getDay() === 0) {
      return date.clone().add({ days: 6 });
    } else {
      return date.clone().moveToDayOfWeek(0, -1).add({ days: 6 });
    }
  },

  /**
   * Determines if the value is a date object
   */
  isDateObject: function (date) {
    return Object.prototype.toString.call(date) === "[object Date]";
  },

  /**
   *
   * Sets the given date to the given time
   */
  setDateToTime(date, time) {
    const time_pieces = time.match(/\d\d:\d\d:\d\d/)[0].split(":");
    date.setHours(parseInt(time_pieces[0]));
    date.setMinutes(parseInt(time_pieces[1]));
    return date;
  },

  /**
   * Compare function, sorts dates ascending
   *
   * @param {date} a
   * @param {date} b
   *
   * @returns {integer} 0, 1, -1
   */
  sortAsc: function (a, b) {
    return Date.parse(a.start_date).compareTo(Date.parse(b.start_date));
  },

  /**
   * Compare function, sorts dates descending
   *
   * @param {date} a
   * @param {date} b
   *
   * @returns {integer} 0, 1, -1
   */
  sortDesc: function (a, b) {
    return Date.parse(b.start_date).compareTo(Date.parse(a.start_date));
  },

  /**
   * Returns a date time string for the given date
   *
   * @param {date} date
   *
   * @return {string}
   */
  timeString: function (date) {
    var format = date.getMinutes() > 0 ? "h:mm" : "h";
    return date.toString(format) + date.toString("t").toLowerCase();
  },

  today: function () {
    var d = this.current();
    d.setHours(0, 0, 0, 0);
    return d;
  },

  toISODateString: function (date) {
    return date.toISOString().split("T")[0];
  },

  /**
   * Convenience function to call parseDateToString
   */
  parseToString: function (date, dateFormat) {
    return this.parseDateToString(date, dateFormat);
  },

  /**
   * Parses date string to Date object, then converts to string with given dateFormat
   */
  parseDateToString: function (date, dateFormat) {
    return this.parseDate(date).toString(this.rubyToDateJS(dateFormat));
  },

  /**
   * Parses date string to Date object, then converts to string with given timeFormat
   */
  parseTimeToString: function (date, timeFormat) {
    return this.parseDate(date).toString(this.rubyToDateJS(timeFormat));
  },

  /**
   * Parses to a date/time string
   */
  parseToDateTimeString: function (date, dateFormat, timeFormat) {
    return this.parseDate(date).toString(
      this.rubyToDateJS(dateFormat) + ", " + this.rubyToDateJS(timeFormat)
    );
  },
};

export default DateHelper;
